/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { Button, Input } from 'reactstrap';
import { createPortfolio } from '../../../../actions/portfolio-tracker';
import { Loader } from '@g17eco/atoms/loader';
import { Portfolio } from '../../../../types/portfolio';

interface PortfolioProps {
  portfolioId: string;
  onCreate: (portfolio: Portfolio) => void;
}

const AddPortfolioForm = (props: PortfolioProps) => {

  const [name, setName] = React.useState<string | undefined>(undefined);
  const [errorMessage, setMessage] = React.useState('');
  const [isSaving, setSaving] = React.useState(false);

  const canSubmit = !!name;

  const handleSubmit = async () => {
    if (!canSubmit) {
      return;
    }
    setMessage('');
    if (isSaving) {
      return;
    }
    setSaving(true);
    try {
      const portfolioData = await createPortfolio(props.portfolioId, name ?? '');
      props.onCreate(portfolioData)
    }
    catch (e) {
      setMessage(e.message);
    }
    setSaving(false);
  }

  if (isSaving) {
    return <Loader relative={true} />;
  }

  return (
    <>
      <h5><i className='fa fa-folder-plus mr-2' />Create a new portfolio</h5>
      {errorMessage && <div className='alert alert-danger'>{errorMessage}</div>}
      <div className='mt-3 ml-4 d-flex'>
        <div className='flex-grow-1 pr-2'>
          <Input
            disabled={isSaving}
            placeholder={'Portfolio name'}
            onChange={(e) => setName(e.target.value)} />
        </div>
        <Button disabled={isSaving || !canSubmit} onClick={handleSubmit}>
          <i className='fa fa-plus mr-2' />Create
        </Button>
      </div>
    </>
  );
}
export default AddPortfolioForm;
